<mat-card class="pageWrapper">
    <mat-card-content>
        <div class="mat-elevation-z8 section-wrap">
            <div class="page-title-wrap">
                <h2 class="page-title">
                    Add New Course
                </h2>
            </div>
            <div class="form-wrap">
                <!-- <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Select Test Name</mat-label>
                    <mat-select>
                        <mat-option value="one">Test 1</mat-option>
                        <mat-option value="two">Test 2</mat-option>
                    </mat-select>
                </mat-form-field> -->
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Specify Course Test Name</mat-label>
                    <input matInput [(ngModel)]="newCourseAssessment">
                </mat-form-field>
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Auto Course Completion</mat-label>
                    <mat-select [(ngModel)]="autoCourseCompletion">
                        <mat-option value="1">Yes</mat-option>
                        <mat-option value="0">No</mat-option>
                    </mat-select>
                </mat-form-field>
                <!-- <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Topic name</mat-label>
                    <input matInput placeholder="Placeholder">
                </mat-form-field>
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Specify Course Id</mat-label>
                    <input matInput placeholder="Placeholder">
                </mat-form-field> -->
                <button mat-raised-button class="button-style" (click)="addNewCourse()">Submit</button>
            </div>
        </div>
    </mat-card-content>
</mat-card>